import * as types from '../../actions/ActionTypes.js';

const registeredDevices = (
    state = {
        isFetching: false,
        entities: {},
        list: []
    },
    action
) => {
    switch (action.type) {
        case types.REQUEST_REGISTERED_DEVICES:
            return {
                ...state,
                isFetching: true
            };
        case types.RECEIVE_REGISTERED_DEVICES:
            return {
                ...state,
                isFetching: false,
                entities: action.registeredDevices.reduce((registeredDevices, device) => {
                    registeredDevices[device.deviceId] = device;
                    return registeredDevices;
                }, {}),
                list: action.registeredDevices,
                lastUpdated: action.receivedAt
            };
        default:
            return state;
    }
};

export const getRegisteredDevices = (state) => {
    return state.registeredDevices.entities;
};

export const getAtpSupportedRegisteredDevices = (state) => {
    return state.registeredDevices.list.filter((device) => !!device.atpWorkoutCapable);
};

export default registeredDevices;
